import { Component, forwardRef, Input } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { DataType, DataTypeOption } from '@core/constants/data-types.constants';

@Component({
  selector: 'mfp-select-currency',
  templateUrl: './select-currency.component.html',
  styleUrls: ['./select-currency.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => SelectCurrencyComponent),
      multi: true
    }
  ]
})
export class SelectCurrencyComponent implements ControlValueAccessor {
  @Input() name = '';
  @Input() required = false;
  @Input() readonly = false;
  @Input() disabled = false;
  @Input() options: {
    key: string;
    value: string;
  }[] = [];

  selectValue = '';
  showOptions = false;

  private innerValue: DataType = '';

  constructor() {}

  toggleOptions(): void {
    if (!this.disabled) {
      this.showOptions = !this.showOptions;
    }
  }

  selectOption(option: DataTypeOption<DataType>): void {
    this.selectValue = option.key;
    this.value = option.value;
    this.toggleOptions();
  }

  // ControlValueAccessor
  private onChangeCallback = (_: DataType) => {};
  private onTouchCallback = () => {};

  get value(): DataType {
    return this.innerValue;
  }

  set value(value: DataType) {
    if (value !== this.innerValue) {
      this.innerValue = value;
      this.onChangeCallback(value);
      this.onTouchCallback();
    }
  }

  writeValue(value: DataType): void {
    if (value !== this.innerValue) {
      this.innerValue = value;
      const option = this.options.find(o => o.value === this.innerValue);
      this.selectValue = option ? option.key : this.selectValue;
    }
  }

  registerOnChange(fn: (_: DataType) => void): void {
    this.onChangeCallback = fn;
  }

  registerOnTouched(fn: () => void): void {
    this.onTouchCallback = fn;
  }

  setDisabledState(state: boolean): void {
    this.disabled = state;
  }
}
